<template>
    <section class="mod mod1">
        <div class="nav2">
            <div class="nav2-wrap">
                <span
                    v-for="(nav, i) in ggNavs"
                    :key="i"
                    :class="curGGNav == i ? 'cur' : ''"
                    @click="navClick(i)"
                    >{{ nav }}</span
                >
            </div>
        </div>
        <div class="date-title">
            <span v-if="curGGNav == 0">{{ dayStr }} {{ week }}</span>
            <ul class="date-list flex" v-else-if="curGGNav == 2" style="width: 80%">
                <li
                    v-for="(date, i) in dateList"
                    :key="i"
                    :class="curDateIndex == i ? 'cur' : ''"
                    @click="riqiSct(i)"
                >
                    {{ date }}
                </li>
            </ul>

            <div class="fr date-picker" v-if="curGGNav == 0">
                <!-- <div @click="jobSearch">oooooo</div> -->
                <input
                    style="width: 100%; text-align: right; font-size: 0.28rem"
                    type="text"
                    v-clickoutside="fun"
                    :readonly="true"
                    v-model="todayDate"
                    @click.stop="Calendartype = !Calendartype"
                />
                <!-- <datepicker @blur="todayDate"  :readonly="true" format="YYYY-MM-DD" name="date1"  :value="todayDate" :class="todayDate.indexOf('0')>0?'actived':''"></datepicker> -->
            </div>
            <!-- <Calendar :value="todayDate" v-show="Calendartype" :class="todayDate.indexOf('0')>0?'actived':''" v-on:choseDay="clickDay" v-on:changeMonth="changeDate" v-on:isToday="clickToday"></Calendar> -->
            <Calendar
                :value="todayDate"
                class="calendar-w"
                v-show="Calendartype"
                v-on:choseDay="clickDay"
                v-on:changeMonth="changeDate"
                v-on:isToday="clickToday"
            ></Calendar>
        </div>

        <div class="nav-sub flex" v-if="curGGNav == 0">
            <span
                v-for="(item, i) in subNavs"
                :key="i"
                :class="curSubNav == i ? 'cur' : ''"
                @click="getInfo(i)"
                >{{ item }}</span
            >
        </div>

        <div class="table-scroll table-scroll-h" v-show="curGGNav == 0">
            <div class="table-l fl">
                <table width="100%" cellspacing="0" cellpadding="0">
                    <tr>
                        <th>名称代码</th>
                    </tr>
                    <tr v-for="(item, index) in topTenList" :key="index">
                        <td
                            @click="
                                gotofs(
                                    item.Dsymbol.substring(
                                        0,
                                        item.Dsymbol.lastIndexOf('.stk')
                                    )
                                )
                            "
                        >
                            {{ item.SENAME
                            }}<small>{{ item.Dsymbol | codeSubStr }}</small>
                        </td>
                    </tr>
                </table>
            </div>
            <div class="table-r">
                <div class="table-r-wrap2  table-r-sdcjg">
                    <table width="100%" cellspacing="0" cellpadding="0">
                        <!-- sort up  箭头上 -->
                        <!-- sort  箭头下 -->
                        <tr>
                            <th
                                :class="
                                    cjSortName == i
                                        ? cjSortFx == 1
                                            ? 'sort'
                                            : 'sort up'
                                        : ''
                                "
                                v-for="(item, i) in ggsdtitle"
                                :key="i"
                                @click="sortList(i)"
                            >
                                {{ item }}
                            </th>
                        </tr>
                        <tr
                            v-for="(item, index) in topTenList"
                            :key="index"
                            @click="gotogzxq(item.Dsymbol, item.SENAME, 1)"
                        >
                            <td>{{ item.TOTALAMT | formateSum }}</td>
                            <td :class="item.PCHG | formateRedGreen">
                                {{ item.PCHG }}%
                            </td>
                            <td><a>明细</a></td>
                        </tr>
                    </table>
                </div>
            </div>
            <div
                v-if="sdNull"
                style="
                    height: 1.5rem;
                    text-align: center;
                    line-height: 1.5rem;
                    font-size: 14px;
                    color: #999999;
                "
            >
                -暂无数据-
            </div>
        </div>

        <!-- 涨幅榜 -->
        <div class="table-scroll table-scroll-h" v-show="curGGNav == 2">
            <div class="table-l fl">
                <table width="100%" cellspacing="0" cellpadding="0">
                    <tr>
                        <th>名称代码</th>
                    </tr>
                    <tr
                        v-for="(item, index) in zhangfuList"
                        :key="index"
                        @click="gotofs(item.Obj)"
                    >
                        <td>
                            {{ item.ZhongWenJianCheng
                            }}<small>{{ item.Obj }}</small>
                        </td>
                    </tr>
                </table>
            </div>
            <div class="table-r">
                <div class="table-r-wrap table-r-wrap4 table-r-zfb">
                    <table width="100%" cellspacing="0" cellpadding="0">
                        <!-- class="sort up" -->
                        <!-- <tr><th class="sort up">涨幅</th><th>成交额</th><th>净流入</th><th>买入金额</th><th>卖出金额</th><th>相关明细</th></tr> -->
                        <tr>
                            <th
                                :class="
                                    sortName == i
                                        ? sortFx == 1
                                            ? 'sort'
                                            : 'sort up'
                                        : ''
                                "
                                v-for="(item, i) in zfbtitle"
                                :key="i"
                                @click="zfSort(item, i)"
                            >
                                {{ item }}
                            </th>
                        </tr>
                        <tr
                            v-for="(item, index) in zhangfuList"
                            :key="index"
                            @click="
                                gotogzxq(item.Obj, item.ZhongWenJianCheng, 2)
                            "
                        >
                            <td :class="item.ChiGuZhangFu | formateRedGreen">
                                {{ item.ChiGuZhangFu | zfNum }}%
                            </td>

                            <td>{{ item.ChiGuShuLiang | getbh }}</td>
                            <td>{{ item.ChiGuShiZhi | cgszNum }}</td>
                            <td>{{ item.ZuiXinJia | zfNum }}</td>
                        </tr>
                    </table>
                </div>
            </div>
            <div
                v-if="GdShow"
                style="text-align: center; padding: 15px 10px"
                @click="jzGengduo()"
            >
                点击加载更多
            </div>
        </div>

        <!-- 重仓榜-->
        <div class="table-scroll table-scroll-h" v-show="curGGNav == 1">
            <div class="table-l fl">
                <table width="100%" cellspacing="0" cellpadding="0">
                    <tr>
                        <th>名称代码</th>
                    </tr>
                    <tr
                        v-for="(item, index) in zhongCangList"
                        :key="index"
                        @click="gotofs(item.Obj)"
                    >
                        <td>
                            {{ item.ZhongWenJianCheng
                            }}<small>{{ item.Obj }}</small>
                        </td>
                    </tr>
                </table>
            </div>
            <div class="table-r">
                <div class="table-r-wrap table-r-wrap5 table-r-zcb">
                    <table width="100%" cellspacing="0" cellpadding="0">
                        <!-- class="sort up" -->
                        <!-- <tr><th class="sort up">涨幅</th><th>成交额</th><th>净流入</th><th>买入金额</th><th>卖出金额</th><th>相关明细</th></tr> -->
                        <tr>
                            <th
                                :class="
                                    sortName == i
                                        ? sortFx == 1
                                            ? 'sort'
                                            : 'sort up'
                                        : ''
                                "
                                v-for="(item, i) in zctitle"
                                :key="i"
                                @click="zfSort(item, i)"
                            >
                                {{ item }}
                            </th>
                        </tr>
                        <tr
                            v-for="(item, index) in zhongCangList"
                            :key="index"
                            @click="
                                gotogzxq(item.Obj, item.ZhongWenJianCheng, 2)
                            "
                        >
                            <td>{{ item.ChiGuShiZhi | cgszNum }}</td>
                            <td>{{ item.ZhanLiuTongGuBiLi | bfbNum }}%</td>
                            <!-- <td :class="item.ChiGuZhangFu | formateRedGreen">
                                {{ item.ChiGuZhangFu | zfNum }}%
                            </td> -->
                        </tr>
                    </table>
                </div>
            </div>
            <div
                v-if="GdShow"
                style="text-align: center; padding: 15px 10px"
                @click="jzGengduo()"
            >
                点击加载更多
            </div>
        </div>
        <div
            v-if="ispop"
            style="
                position: fixed;
                left: 40%;
                bottom: 15%;
                background: rgba(0, 0, 0, 0.5);
                z-index: 998;
                width: 20%;
                text-align: center;
                padding: 0.1rem 0.1rem;
                border-radius: 0.1rem;
                color: #ffffff;
            "
        >
            <!-- <div style="position: absolute;bottom: 14%;z-index: 999;width:20%;border"></div> -->
            当日无数据
        </div>
    </section>
</template>

<script>
// import datepicker from 'vue-date-picker'
import { hsgtsdcj } from "@/api/index.js";
import { Calendars } from "@/api/index.js";
import { ggtj } from "@/api/bxzj.js";
import Calendar from "vue-calendar-component";

export default {
    name: "GeGu",
    components: {
        // datepicker,
        Calendar,
    },
    data() {
        return {
            GdShow: true,
            ispop: false,
            CalendarsList: [], //交易日历
            Calendartype: false,
            //涨幅榜
            pagesize: 20,
            zfdesc: true,
            page: 1,
            block: "股票/市场分类/全部A股",
            orderby: "ChiGuZhangFu5",
            day: 5,
            sortName: "ChiGuZhangFu",
            sortFx: 1, // 1 倒叙   2  正序
            zhangfuList: [],
            zfbtitle: {
                ChiGuZhangFu: "涨幅",
                ChiGuShuLiang: "持股量",
                ChiGuShiZhi: "持股市值",
                ZuiXinJia: "收盘价",
            },

            //重仓
            zhongCangList: [],
            zctitle: {
                ChiGuShiZhi: "港股持股市值",
                ZhanLiuTongGuBiLi: "占流通A股比例",
                // ChiGuZhangFu: "涨幅",
            },

            ggsdclass: "",
            ggsdtitle: {
                TOTALAMT: "成交额",
                PCHG: "涨幅",
                xiangguan: "相关明细",
            },
            curGGNav: 0,
            ggNavs: ["十大成交股", "重仓榜"],
            curSubNav: 0,
            // subNavs:['全部','沪股通','深股通'],
            subNavs: ["沪股通", "深股通"],
            topTenList: [],
            todayDate: "自定义日期",
            curDateIndex: 0,
            dateList: ["当日", "近5日", "近20日", "近60日", "近120日"],
            dateNumList: ["1", "5", "20", "60", "120"],
            dayStr: "", //当日时间
            week: "",
            shenList: [],
            huList: [],
            cjSortName: "TOTALAMT",
            cjSortFx: 1,
            sdDate: "", //十大成交
            sdNull: false,
        };
    },
    watch: {
        todayDate: function (val) {},
    },
    directives: {
        clickoutside: {
            // 初始化指令
            bind(el, binding, vnode) {
                function documentHandler(e) {
                    // 这里判断点击的元素是否是本身，是本身，则返回
                    if (el.contains(e.target)) {
                        return false;
                    }
                    // 判断指令中是否绑定了函数
                    if (binding.expression) {
                        // 如果绑定了函数 则调用那个函数，此处binding.value就是handleClose方法
                        binding.value(e);
                    }
                }
                // 给当前元素绑定个私有变量，方便在unbind中可以解除事件监听
                el.__vueClickOutside__ = documentHandler;
                document.addEventListener("click", documentHandler);
            },
            update() {},
            unbind(el, binding) {
                // 解除事件监听
                document.removeEventListener("click", el.__vueClickOutside__);
                delete el.__vueClickOutside__;
            },
        },
    },
    mounted: function () {
        this.getInfo(0);

        Calendars().then((res) => {
            this.CalendarsList = res.data.data.list;
        });
    },
    methods: {
        fun: function () {
            this.Calendartype = false;
        },
        clickDay(data) {
            var date = new Date(data);
            var Y = date.getFullYear();
            var M =
                date.getMonth() + 1 < 10
                    ? date.getMonth() + 1
                    : date.getMonth() + 1;
            var D = date.getDate();
            if (M < 10) {
                M = "0" + M;
            }

            if (D < 10) {
                D = "0" + D;
            }

            var sdDate = String(Y) + M + D;

            this.Calendartype = false;

            var newDate = new Date();
            var YY = newDate.getFullYear();
            var MM =
                newDate.getMonth() + 1 < 10
                    ? newDate.getMonth() + 1
                    : newDate.getMonth() + 1;
            var DD = newDate.getDate();
            if (MM < 10) {
                MM = "0" + MM;
            }

            if (DD < 10) {
                DD = "0" + DD;
            }

            var newDateStr = YY + String(MM) + DD;

            if (
                this.CalendarsList.indexOf(sdDate) === -1 ||
                newDateStr < sdDate
            ) {
                this.ispop = true;

                var that = this;
                setTimeout(function () {
                    that.ispop = false;
                }, 2000);

                return false;
            }
            this.todayDate = data;
            this.sdDate = sdDate;
            this.getInfo(this.curSubNav);
            return false;
        },
        changeDate(data) {
            event.stopPropagation();
        },
        clickToday(data) {},
        getDataTime: function (time) {
            var weeks = new Array(
                "星期日",
                "星期一",
                "星期二",
                "星期三",
                "星期四",
                "星期五",
                "星期六"
            );

            var date = new Date(time);

            var Y = date.getFullYear();
            var M =
                date.getMonth() + 1 < 10
                    ? date.getMonth() + 1
                    : date.getMonth() + 1;
            var D = date.getDate();

            this.dayStr = Y + "/" + M + "/" + D;
            this.week = weeks[date.getDay()];
        },
        //获取十大成交股
        getInfo(code) {
            //code 0 全部  1沪   2深
            //type   2 港股通沪   4 港股通 深
            this.curSubNav = code;
            if (code == 0) {
                hsgtsdcj({
                    type: 1,
                    date: this.sdDate,
                    page: 1,
                    size: 10,
                }).then((res) => {
                    //topTenList

                    if (
                        res.data.err == 0 &&
                        res.data.data.list &&
                        res.data.data.list.length > 0
                    ) {
                        this.sdNull = false;

                        this.getDataTime(
                            new Date(
                                res.data.data.date.slice(0, 4) +
                                    "-" +
                                    res.data.data.date.slice(4, 6) +
                                    "-" +
                                    res.data.data.date.slice(6)
                            )
                        );
                        var data = res.data.data;
                        if (data.list) {
                            this.topTenList = data.list;
                        }
                    } else {
                        this.topTenList = [];
                        this.dayStr = this.todayDate;

                        this.sdNull = true;
                    }
                });
                // this.huList = this.getHuShenlist({'type':1,date:'','page':1,'size':10});
            } else if (code == 1) {
                hsgtsdcj({
                    type: 3,
                    date: this.sdDate,
                    page: 1,
                    size: 10,
                }).then((res) => {
                    //topTenList
                    if (res.data.err == 0 && res.data.data.list.length > 0) {
                        this.sdNull = false;
                        this.getDataTime(
                            new Date(
                                res.data.data.date.slice(0, 4) +
                                    "-" +
                                    res.data.data.date.slice(4, 6) +
                                    "-" +
                                    res.data.data.date.slice(6)
                            )
                        );
                        var data = res.data.data;
                        if (data.list) {
                            this.topTenList = data.list;
                        }
                    } else {
                        this.topTenList = [];
                        this.dayStr = this.todayDate;

                        this.sdNull = true;
                    }
                });
                // this.shenList = this.getHuShenlist({'type':3,date:'','page':1,'size':10});
            } else if (code == 3) {
                hsgtsdcj({
                    type: 1,
                    date: this.sdDate,
                    page: 1,
                    size: 10,
                }).then((res) => {
                    //topTenList
                    if (res.data.err == 0) {
                        let data = res.data.data;

                        if (data.list) {
                            hsgtsdcj({
                                type: 3,
                                date: "",
                                page: 1,
                                size: 10,
                            }).then((res01) => {
                                //topTenList
                                if (res01.data.err == 0) {
                                    let data01 = res01.data.data;
                                    if (data01.list) {
                                        for (let x in data01.list) {
                                            data.list.push(data01.list[x]);
                                        }

                                        this.topTenList = data.list.sort(
                                            this.compare("TOTALAMT")
                                        );
                                    }
                                }
                            });
                        }
                    }
                });
            }
        },
        //获取沪深十大成交股   未使用
        getHuShenlist: function (params) {
            hsgtsdcj(params).then((res) => {
                if (res.data.err == 0) {
                    var data = res.data.data;
                    if (data.list) {
                        return data.list;
                    }
                }
            });
        },

        navClick: function (i) {
            this.curGGNav = i;
            if (i == 0) {
                this.getInfo(0);
            } else if (i == 1) {
                this.GdShow = true;

                //重仓榜
                this.zfdesc = true;
                this.sortName = "ChiGuShiZhi";
                this.sortFx = 1;
                this.zfdesc = true;

                this.page = 1;
                this.zhongCangList = [];
                this.orderby = "ChiGuShiZhi";
                this.day = 1;
                this.getYptList(this.block, this.orderby, this.day);
            } else if (i == 2) {
                this.GdShow = true;
                this.page = 1;
                this.sortName = "ChiGuZhangFu";
                this.sortFx = 1;
                this.zfdesc = true;
                this.curDateIndex = 0;
                this.zhangfuList = [];
                // this.orderby = 'ChiGuZhangFu'+this.dateNumList[0];
                this.orderby = "ChiGuZhangFu";
                this.day = this.dateNumList[0];
                this.getYptList(this.block, this.orderby, this.day);
            }
        },

        //获取涨幅榜列表
        getYptList: function (block, orderby, day) {
            //this.getZfList("股票/市场分类/全部A股","ChiGuZhangFu5","20",5);

            var start = (this.page - 1) * this.pagesize + 1;

            var params = {
                block: block,
                orderby: orderby,
                count: this.pagesize,
                day: day,
                start: start,
                desc: this.zfdesc,
            };
            ggtj(params).then((res) => {
                //topTenList
                if (res.data.err == 0) {
                    if (res.data.data.list.length < this.pagesize) {
                        this.GdShow = false;
                    }

                    res.data.data.list.forEach((element) => {
                        if (this.curGGNav == 2) {
                            this.zhangfuList.push(element);
                        } else if (this.curGGNav == 1) {
                            this.zhongCangList.push(element);
                        }
                    });
                    this.page = this.page + 1;
                }
            });
        },

        //十大成交股点击排序
        sortList: function (i) {
            if (i == "xiangguan") {
                return false;
            }

            if (i == this.cjSortName) {
                if (this.cjSortFx == 1) {
                    this.cjSortFx = 2;
                } else {
                    this.cjSortFx = 1;
                }
            }
            this.cjSortName = i;

            if (this.cjSortFx == 1) {
                this.topTenList.sort(this.compare(i));
            } else {
                this.topTenList.sort(this.compare02(i));
            }
        },

        //涨幅排序
        zfSort: function (item, i) {
            this.GdShow = true;
            if (this.sortName == i) {
                if (this.sortFx == 1) {
                    this.sortFx = 2;
                } else {
                    this.sortFx = 1;
                }
            } else {
                this.sortFx = 1;
            }

            if (this.sortFx == 1) {
                this.zfdesc = true;
            } else {
                this.zfdesc = false;
            }
            this.sortName = i;
            this.page = 1;
            this.zhangfuList = [];
            this.jingLiuRuList = [];
            this.zhongCangList = [];
            this.day = this.dateNumList[this.curDateIndex];
            // this.curDateIndex = 0;
            if (
                i != "LianXuZenCangTianShu" &&
                i != "ChiGuShiZhi" &&
                i != "ChiGuShuLiang" &&
                i != "ZuiXinJia" &&
                i != "ZhanLiuTongGuBiLi"
            ) {
                this.orderby = i + this.day;
                if (i == "ChiGuZhangFu" && this.day == 1) {
                    this.orderby = i;
                }
            } else {
                this.orderby = i;
            }

            this.getYptList(this.block, this.orderby, this.day);
        },
        //自定义日期搜索
        jobSearch: function () {
            var form = document.getElementsByName("date1");

            var date = new Date(form[0]._value);

            var Y = date.getFullYear();
            var M =
                date.getMonth() + 1 < 10
                    ? date.getMonth() + 1
                    : date.getMonth() + 1;
            var D = date.getDate();

            this.sdDate =
                String(Y) +
                String(M >= 10 ? M : "0" + M) +
                String(D >= 10 ? D : "0" + D);
            this.getInfo(this.curSubNav);
        },

        //日期搜索 5日  20日  60日   120日
        riqiSct: function (i) {
            this.GdShow = true;
            //涨幅榜
            if (this.curGGNav == 2) {
                if (this.curDateIndex == i) {
                    return false;
                }

                // this.sortName = 'ChiGuZhangFu';
                this.sortFx = 1;
                this.curDateIndex = i;
                this.page = 1;
                this.zhangfuList = [];

                this.day = this.dateNumList[i];
                // this.orderby = 'ChiGuZhangFu'+this.dateNumList[i];
                this.orderby = this.sortName + this.dateNumList[i];
                if (this.dateNumList[i] == 1) {
                    this.orderby = this.sortName;
                }

                this.getYptList(this.block, this.orderby, this.day);
            }

            //净流入榜
            else if (this.curGGNav == 1) {
                if (this.curDateIndex == i) {
                    return false;
                }
                // this.sortName = 'ChiGuShiZhiBianHua';
                this.sortFx = 1;
                this.curDateIndex = i;
                this.page = 1;
                this.jingLiuRuList = [];

                this.day = this.dateNumList[i];
                // this.orderby = 'ChiGuShiZhiBianHua'+this.dateNumList[i];
                this.orderby = this.sortName + this.dateNumList[i];

                this.getYptList(this.block, this.orderby, this.day);
            } else if (this.curGGNav == 3) {
                if (this.curDateIndex == i) {
                    return false;
                }
                // this.sortName = 'ChiGuShiZhiBianHua';
                this.sortFx = 2;
                this.curDateIndex = i;
                this.page = 1;
                this.jingLiuRuList = [];

                this.day = this.dateNumList[i];
                // this.orderby = 'ChiGuShiZhiBianHua'+this.dateNumList[i];
                this.orderby = this.sortName + this.dateNumList[i];

                this.getYptList(this.block, this.orderby, this.day);
            }
        },

        //跳转分时
        gotofs: function (code) {
            //code =  code.substring(0, code.lastIndexOf('.stk'));

            location.href =
                "dzh_browser_url&goto=0&type=2970&code=" +
                code.replace(/FX/, "FE") +
                "&kind=1";
        },

        //加载更多
        jzGengduo: function () {
            var block = this.block;
            var orderby = this.orderby;
            var day = this.day;
            this.getYptList(block, orderby, day);
        },
        handlerScroll: function () {
            var scrollTop = this.$refs.personDom.scrollTop; //滑入屏幕上方的高度
            var windowHeitht = this.$refs.personDom.clientHeight; //能看到的页面的高度
            var scrollHeight = this.$refs.personDom.scrollHeight; //监控的整个div的高度（包括现在看到的和上下隐藏起来看不到的）
            let total = scrollTop + windowHeitht;

            if (total == scrollHeight) {
                var block = this.block;
                var orderby = this.orderby;
                var day = this.day;
                this.getYptList(block, orderby, day);
            }
        },

        //跳转股票详情页
        gotogzxq: function (code, name, index) {
            if (index == 1) {
                code = code.substring(0, code.lastIndexOf(".stk"));
            }
            location.href =
                window.location.protocol +
                "//" +
                window.location.host +
                window.location.pathname +
                "#/ss/" +
                code +
                "/" +
                name +
                "?DZHSPECIAL=265";
        },

        compare(property) {
            return function (a, b) {
                var value1 = a[property];
                var value2 = b[property];
                return value2 - value1;
            };
        },
        compare02(property) {
            return function (a, b) {
                var value1 = a[property];
                var value2 = b[property];
                return value1 - value2;
            };
        },
    },
    filters: {
        codeSubStr: function (v) {
            return v.substring(0, v.lastIndexOf(".stk"));
        },
        formateTag: function (v) {
            if (v == undefined || v == null) return;
            if (v > 0) return "交易中";
            if (v < 0) return "已结束";
        },
        formatePrefixData: function (v) {
            if (v == undefined || v == null) return "--";
            if (v > 0) return "+" + v;
            if (v < 0) return v;
        },
        formateRedGreen: function (v) {
            if (v == undefined || v == null) return;
            if (v > 0) return "ft-red";
            if (v < 0) return "ft-green";
        },
        formateSum: function (v) {
            if (Math.abs(v) < 100000000) {
                return (v / 10000).toFixed(2) + "万";
            } else {
                return (v / 100000000).toFixed(2) + "亿";
            }
        },
        bfbNum: function (v) {
            if (v == 0) {
                return "0.00";
            } else {
                return v;
            }
        },
        zfNum: function (v) {
            var num = v.toFixed(2);

            var arrayNum = num.toString().split(".");

            if (arrayNum[1] != undefined) {
                for (var i = arrayNum[1].length; i < 2; i++) {
                    num += "0";
                }
            } else {
                num += ".00";
            }
            return num;
        },
        cgszNum: function (v) {
            var num = v * 100000000;
            //v 单位万元
            if (Math.abs(num) < 100000000 && Math.abs(v) > 0) {
                return (num / 10000).toFixed(2) + "万";
            } else if (Math.abs(num) >= 100000000) {
                return (num / 100000000).toFixed(2) + "亿";
            } else {
                return "0";
            }
        },

        getbh: function (v) {
            //v 单位万元
            if (Math.abs(v) < 10000 && Math.abs(v) > 0) {
                return v.toFixed(2) + "万";
            } else if (Math.abs(v) >= 10000) {
                return (v / 10000).toFixed(2) + "亿";
            } else {
                return "0";
            }
        },
    },
};
</script>
